import React, { useRef, useCallback } from "react";

const InfiniteScroll = ({
  fetchMoreData,
  hasMore,
  isLoading,
  children,
  threshold = 200,
}) => {
  // console.log('inside',fetchMoreData, hasMore, isLoading, children);
  const observer = useRef();

  const lastElementRef = useCallback(
    (node) => {
      if (isLoading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchMoreData();
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore, fetchMoreData]
  );

  return (
    <div style={{ overflow: "auto", maxHeight: "70vh" }}>
      {children}
      <div ref={lastElementRef} style={{ height: "1px" }} />
    </div>
  );
};

export default InfiniteScroll;